module.exports = __webpack_public_path__ + "img/1.eac32a11.jpg";